
import React, { Component, forwardRef } from "react";
import './custom-form.component.css'
import { Control, Errors, actions } from 'react-redux-form';
import { Form, Button, FloatingLabel, DropdownButton } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { capitalizeFirstLetter } from '../../../utils/helpers.utils'
import { INVALID_CHARS, INPUT_FIELD_TYPE, DATA_TYPE, FiveDecimalPlaces } from "../../../constants/external-constants"
import store from "../../../store";

export class SelectField extends Component {

    render() {
        const { label, options, onChange, selected, customClass, placeholder, requiredField } = this.props;

        return (
            <div className={`custom-select-container ${requiredField ? "required" : ""} ${customClass}`}>
                <div className="custom-select-label select-floating-label">{label}</div>
                <select className="form-select select-container" id="floatingSelect" onChange={onChange} value={selected ? selected : ""}>
                    <option hidden disabled value="">{placeholder}</option>
                    {options?.map(items =>
                        <option key={items.FilterId} value={items.FilterValue === undefined ? items.FilterName : items.FilterValue}>{items.FilterName}</option>
                    )}
                </select>
            </div>
        );
    }

}

export class SelectFieldEquipment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            selected: false
        };
    }

    displayOptions = data => {
        if (data !== undefined && data !== null && data.length > 0) {
            return data.map(x => {
                return (
                    <option value={x.Key} key={'option-' + x.Key + x.Value} id={x.Value}>
                        {x.Value}
                    </option>
                );
            });
        }
    };

    onChangeAction = (model, value) => {
        const { onChangeAction } = this.props;
        if (onChangeAction !== undefined && onChangeAction !== null) {
            onChangeAction(model, value);
        }
    };

    render() {
        const { options, value, fieldProp, placeholder, label, disabled, onChangeAction
            //field validation
            , validators, errorMessages, valid, className, customClass } = this.props;
        return (
            <div className={`custom-select-container ${customClass}`}>
                <div className="custom-select-label">{label}</div>
                <Control.select
                    className="pets"
                    value={value}
                    model={fieldProp}
                    validators={validators}
                    changeAction={onChangeAction !== undefined ? this.onChangeAction : undefined}
                    disabled={disabled}
                    id="floatingSelect"
                >
                    <option hidden>{placeholder}</option>
                    {this.displayOptions(options)}
                </Control.select>
            </div>

        );
    }

}

export class SelectFieldKeyValue extends Component {

    render() {
        const { label, options, onChange, selected } = this.props;

        return (
            <div className="custom-select-container">
                <div className="custom-select-label">{label}</div>
                <select className="pets" id="floatingSelect" onChange={onChange} value={selected ? selected : ""}>
                    <option hidden disabled value="">{label}</option>
                    {options.map(items =>
                        <option key={items.Key} value={items.Value}>{items.Value}</option>
                    )}
                </select>
            </div>
        );
    }

}

export class SelectFieldBillingAccount extends Component {

    render() {
        const { label, options, onChange, selected } = this.props;

        return (
            <div className="custom-select-container">
                <div className="custom-select-label">{label}</div>
                <select className="pets" id="floatingSelect" onChange={onChange} value={selected ? selected : ""}>
                    <option hidden disabled value="">{label}</option>
                    {options.map(items =>
                        <option key={items.BillingAccountID} value={items.BillingAccount}>{items.BillingAccount}</option>
                    )}
                </select>
            </div>
        );
    }

}

export class SelectFieldFloatingLabel_BillingAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            selected: false
        };
    }

    displayOptions = data => {
        if (data !== undefined && data !== null && data.length > 0) {
            return data.map(x => {
                return (
                    <option value={x.BillingAccountID} key={'option-' + x.BillingAccountID + x.BillingAccount} id={x.BillingAccount}>
                        {x.BillingAccount}
                    </option>
                );
            });
        }
    };

    onChangeAction = (model, value) => {
        const { onChangeAction } = this.props;
        if (onChangeAction !== undefined && onChangeAction !== null) {
            onChangeAction(model, value);
        }
    };

    render() {
        const { options, value, fieldProp, placeholder, label, disabled, onChangeAction
            , validators, errorMessages, valid, className } = this.props;
        return (
            <div>
                <FloatingLabel controlId="floatingSelect" label={label}>
                    <Control.select
                        className={className}
                        value={value}
                        model={fieldProp}
                        validators={validators}
                        changeAction={onChangeAction !== undefined ? this.onChangeAction : undefined}
                        disabled={disabled}
                    >
                        <option hidden>{placeholder}</option>
                        {this.displayOptions(options)}
                    </Control.select>
                </FloatingLabel>
                {
                }
            </div>
        );
    }
}

export class SelectFieldFloatingLabel_UserHRID extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            selected: false
        };
    }

    displayOptions = data => {
        if (data !== undefined && data !== null && data.length > 0) {
            return data.map(x => {
                return (
                    <option value={x.EmployeeID} key={'option-' + x.EmployeeID + x.Idhr} id={x.Idhr}>
                        {x.Idhr}
                    </option>
                );
            });
        }
    };

    onChangeAction = (model, value) => {
        const { onChangeAction } = this.props;
        if (onChangeAction !== undefined && onChangeAction !== null) {
            onChangeAction(model, value);
        }
    };

    render() {
        const { options, value, fieldProp, placeholder, label, disabled, onChangeAction
            , validators, errorMessages, valid, className } = this.props;
        return (
            <div>
                <FloatingLabel controlId="floatingSelect" label={label}>
                    <Control.select
                        className={className}
                        value={value}
                        model={fieldProp}
                        validators={validators}
                        changeAction={onChangeAction !== undefined ? this.onChangeAction : undefined}
                        disabled={disabled}
                    >
                        <option hidden>{placeholder}</option>
                        {this.displayOptions(options)}
                    </Control.select>
                </FloatingLabel>
                {
                }
            </div>
        );
    }
}

export class SelectFieldFloatingLabel_Ranking extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            selected: false
        };
    }

    displayOptions = data => {
        if (data !== undefined && data !== null && data.length > 0) {
            return data.map(x => {
                return (
                    <option value={x.Value} key={'option-' + x.Key + x.Value} id={x.Value}>
                        {x.Value}
                    </option>
                );
            });
        }
    };

    onChangeAction = (model, value) => {
        const { onChangeAction } = this.props;
        if (onChangeAction !== undefined && onChangeAction !== null) {
            onChangeAction(model, value);
        }
    };

    render() {
        const { options, value, fieldProp, placeholder, label, disabled, onChangeAction
            , validators, errorMessages, valid, className } = this.props;
        return (
            <div>
                <FloatingLabel controlId="floatingSelect" label={label}>
                    <Errors model={fieldProp} className="has-error" />
                    <Control.select
                        className={`control-field ${className}`}
                        value={value}
                        model={fieldProp}
                        validators={validators}
                        changeAction={onChangeAction !== undefined ? this.onChangeAction : undefined}
                        disabled={disabled}
                    >
                        <option hidden>{placeholder}</option>
                        {this.displayOptions(options)}
                    </Control.select>
                </FloatingLabel>
                {
                }
            </div>
        );
    }
}

export class SelectFieldFloatingLabel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            selected: false
        };
    }

    displayOptions = data => {
        const { className, optionLabelKey } = this.props;
        var targetOption = { Key: 0, Value: this.props.placeholder };
        const nullableData = Array.isArray(data) ? data : []; // Default to an empty array if data is null or invalid
        if (className && (className.includes("required") || className.includes("no-placeholder"))) {
            targetOption = [...nullableData];
        } else {
            targetOption = [targetOption, ...nullableData];
        }
        if (optionLabelKey) {
            return targetOption.map((x, index) => {
                return (
                    <option value={x[optionLabelKey.Key]} key={`option-${x[optionLabelKey.Key]}${x[optionLabelKey.Value]}`} id={`${index}_${x.Key}`}>
                        {x[optionLabelKey.Value]}
                    </option>
                );
            });
        }
        else {
            return targetOption.map((x, index) => {
                return (
                    <option value={x.Key} key={'option-' + x.Key + x.Value} id={`${index}_${x.Key}`}>
                        {x.Value}
                    </option>
                );
            });
        }
    };

    onChangeAction = (model, value, selected) => {
        const { onChangeAction } = this.props;

        if (onChangeAction !== undefined && onChangeAction !== null) {
            onChangeAction(model, value);
        }

        if (selected) {
            onChangeAction(model, value, selected);
        }
    };

    render() {
        const { options, value, fieldProp, placeholder, label, disabled, onChangeAction
            //field validation
            , validators, errorMessages, valid, className, isError } = this.props;
        return (
            <div className={`${isError ? "border-red" : ""}`}>
                <FloatingLabel controlId="floatingSelect" label={label}>
                    <Control.select
                        className={`${className} ${!value ? 'has-placeholder' : ''}`}
                        value={value ? String(value) : ""}
                        model={fieldProp}
                        validators={validators}
                        changeAction={onChangeAction !== undefined ? this.onChangeAction : undefined}
                        disabled={disabled}
                    >
                        <option value="" className="placeholder-option" disabled hidden>{placeholder}</option>
                        {this.displayOptions(options)}
                    </Control.select>
                </FloatingLabel>
                {
                    //<Errors
                    //    className="rrf-errors"
                    //    model={fieldProp}
                    //    show="touch"
                    //    messages={errorMessages}
                    ///>
                }
            </div>
        );
    }
}

export class SelectFieldFloatingLabel_LocationSite extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            selected: false
        };
    }

    displayOptions = data => {
        if (data !== undefined && data !== null && data.length > 0) {
            return data.map(x => {
                return (
                    <option value={x.LocationId} key={'option-' + x.LocationId + x.LocationSite} id={x.LocationSite}>
                        {x.LocationSite}
                    </option>
                );
            });
        }
    };

    onChangeAction = (model, value) => {
        const { onChangeAction } = this.props;
        if (onChangeAction !== undefined && onChangeAction !== null) {
            onChangeAction(model, value);
        }
    };

    render() {
        const { options, value, fieldProp, placeholder, label, disabled, onChangeAction
            , validators, errorMessages, valid, className } = this.props;
        return (
            <div>
                <FloatingLabel controlId="floatingSelect" label={label}>
                    <Control.select
                        className={className}
                        value={value}
                        model={fieldProp}
                        validators={validators}
                        changeAction={onChangeAction !== undefined ? this.onChangeAction : undefined}
                        disabled={disabled}
                    >
                        <option hidden>{placeholder}</option>
                        {this.displayOptions(options)}
                    </Control.select>
                </FloatingLabel>
                {
                }
            </div>
        );
    }
}

export class InputFieldFloatingLabel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            localValue: '',
        };
    }

    componentDidMount() {
        this.setState({
            localValue: this.props.value
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                localValue: this.props.value
            });
        }
    }

    handleChangeAction = (model, value) => {
        const { onChangeAction, inputType, decimalPlaces, hasNegativeValue } = this.props;
        let newValue = value;

        if (inputType === DATA_TYPE.decimal) {
            // Allow digits, dot, and optional leading minus
            const regex = hasNegativeValue ? /[^0-9.-]/g : /[^0-9.]/g;
            newValue = newValue.replace(regex, '');

            // Ensure minus is only at the start
            if (hasNegativeValue) {
                newValue = newValue.replace(/-/g, ''); // remove all minus
                if (value.startsWith('-')) newValue = '-' + newValue; // add minus at start if original started with -
            }

            // Merge extra dots
            const parts = newValue.split('.');
            if (parts.length > 2) {
                newValue = parts[0] + '.' + parts.slice(1).join('');
            }

            // Limit decimal places
            const decimalPart = newValue.split('.')[1];
            if (decimalPart) {
                const maxDecimals = decimalPlaces === FiveDecimalPlaces ? 5 : 2;
                newValue = newValue.split('.')[0] + '.' + decimalPart.slice(0, maxDecimals);
            }

            // Allow temporary typing: '-', '-.', or ''
            const isTempValid = newValue === '-' || newValue === '-.' || newValue === '';
            if (!isTempValid && isNaN(Number(newValue))) {
                newValue = newValue.slice(0, -1);
            }

        } else if (inputType === DATA_TYPE.int) {
            const regexInt = hasNegativeValue ? /[^0-9-]/g : /[^0-9]/g;
            newValue = newValue.replace(regexInt, '');

            if (hasNegativeValue) {
                // minus only at start
                newValue = newValue.replace(/-/g, '');
                if (value.startsWith('-')) newValue = '-' + newValue;
            }
        }

        if (onChangeAction) onChangeAction(model, newValue);
        this.setState({ localValue: newValue });
        store.dispatch(actions.change(model, newValue));
    };


    handleOnBlur = () => {
        const { onBlurAction, value, fieldProp, inputType, decimalPlaces, hasDecimalLimit, decimalFormat } = this.props;
        let newValue = value ?? "";

        if (typeof newValue !== "string") {
            newValue = String(newValue);
        }

        if (inputType === DATA_TYPE.decimal) {
            if (newValue.startsWith('.')) {
                newValue = '0' + newValue;
            }

            if (newValue !== '' && /^-?\d+$/.test(newValue)) {
                if (decimalPlaces === FiveDecimalPlaces) {
                    newValue += ".00000";
                } else {
                    newValue += ".00";
                }
            }
            else if (newValue === '' || newValue === '-') {
                newValue = "0.00";
            }
        }

        //decimal format
        if (hasDecimalLimit && decimalFormat && Array.isArray(decimalFormat)) {
            const [wholeLimit, decimalLimit] = decimalFormat;

            if (newValue) {
                let [whole, decimal = ''] = newValue.split('.');

                whole = whole.replace(/^0+(?=\d)/, '');
                if (decimal.length < decimalLimit) {
                    decimal = decimal.padEnd(decimalLimit, '0');
                } else {
                    decimal = decimal.substring(0, decimalLimit);
                }

                newValue = `${whole}.${decimal}`;
            }
        }

        if (onBlurAction !== undefined && onBlurAction !== null) {
            onBlurAction(fieldProp, newValue);
        } else {
            store.dispatch(actions.change(fieldProp, newValue));
        }
    }

    checkValue = (e) => {
        const { type, inputType,  decimalFormat } = this.props;
        const key = e.key;
        var value = e.target.value;
        var number = value.split('.');
        var isValid = this.validateDecimal(value);
    
        const cursorPosition = e.target.selectionStart;
        const decimalIndex = value.indexOf('.');
        const [whole, decimal = ''] = value.split('.');
    
        let part = 'whole';
        if (decimalIndex !== -1 && cursorPosition > decimalIndex) {
            part = 'decimal';
        }
    
    
        if (inputType == DATA_TYPE.decimal) {
            if (isValid === 0 || isValid === 1) {
                if (this.isProperDecimal(value)) {
                    if (number.length === 2 && e.key == '.') {
                        e.preventDefault();
                    }
                } else {
                    e.preventDefault();
                }
            } else if (isValid == 2) {
                if (key !== '-' && this.props.hasNegativeValue && e.target.selectionStart !== 0) {
                    return;
                }
                else {
                    e.preventDefault();
                }
            }
        } else if (inputType === DATA_TYPE.int) {
            if (/[^0-9]/.test(e.key)) {
                e.preventDefault();
            }
        }
    
        if (INVALID_CHARS.includes(e.key) && type === INPUT_FIELD_TYPE.type) {
            e.preventDefault();
        }
    
        if (this.props.hasDecimalLimit) {
            if (
                key === 'Backspace' || key === 'Delete' || key === 'ArrowLeft' || key === 'ArrowRight' || key === 'Tab'
            ) {
                return;
            }
    
            if (!/[\d.]/.test(key)) {
                if (key === '-' && this.props.hasNegativeValue && e.target.selectionStart === 0) {
                    return;
                }
                e.preventDefault();
                return;
            }

            if (key === '.') {
                return;
            }
    
            if (key === '.' && value.includes('.')) {
                e.preventDefault();
                return;
            }
    
            if ((whole.length >= decimalFormat[0]) && part === 'whole') {
                e.preventDefault();
                return;
            }
    
            if (value.includes('.') && decimal.length >= decimalFormat[1] && part === 'decimal') {              
                e.preventDefault();
                return;
            }
        }
    }


    validateDecimal = (value) => {
        var re = /^[0-9.]*$/
        if (value == null || value == "") {
            return 1;
        }
        else {
            return (re.test(value)) ? 0 : 2;
        }
    }
    isProperDecimal = (value) => {
        var number = value.split('.');
        if (number.length === 1) {
            if (value.length < 49) {
                return true;
            }
        }
        else if (number.length === 2) {
            var wholeNum = number[0];
            var decimalNum = number[1];
            if (wholeNum.length < 43 && decimalNum.length < 7) {
                return true;
            }
        }
        return false;
    }

    render() {
        const { hidden, disabled, label, value, fieldProp, className, type, maxLength, placeholder, requiredField,isError } = this.props;
        return (
            <Form.Group hidden={hidden}>
                <FloatingLabel className={`input-field ${requiredField ? 'required' : ''}`} controlId={label} label={label} hidden={hidden}>
                    <Errors model={fieldProp} className="has-error" />
                    <Control
                        type={type}
                        className={`control-field ${className} ${isError ? 'border-red' : ''}`}
                        value={this.state.localValue ?? ''}
                        model={fieldProp}
                        changeAction={this.handleChangeAction}
                        onBlur={this.handleOnBlur}
                        //validators={validators}
                        placeholder={placeholder}
                        disabled={disabled}
                        onKeyDown={this.checkValue}
                        maxLength={maxLength}
                        persist={true}
                    />
                    <Errors
                        className={`control-errors ${requiredField ? 'required' : ''}`}
                        model={fieldProp}
                    />
                </FloatingLabel>
            </Form.Group>
        )
    }
}

export class SelectField_Inventory_AddPlans extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            selected: false
        };
    }

    displayOptions = (fieldProp, data) => {
        if (data !== undefined && data !== null && data.length > 0) {
            return data.map(x => {
                switch (fieldProp) {
                    case fieldProp = 'inventorycircuit_plans':
                        return (
                            <option value={x.PlanId} key={'option-' + x.PlanId + x.PlanName} id={x.PlanName}>
                                {x.PlanName}
                            </option>
                        );
                    default:
                        return (
                            <option value={x.Key} key={'option-' + x.Key + x.Value} id={x.Value}>
                                {x.Value}
                            </option>
                        );
                }
            });
        }
    };

    onChangeAction = (model, value) => {
        const { onChangeAction } = this.props;
        if (onChangeAction !== undefined && onChangeAction !== null) {
            onChangeAction(model, value);
        }
    };

    render() {
        const { options, value, fieldProp, placeholder, label, disabled, onChangeAction
            , validators, errorMessages, valid, className } = this.props;
        return (
            <div>
                <FloatingLabel controlId="floatingSelect" label={label}>
                    <Control.select
                        className={className}
                        value={value}
                        model={fieldProp}
                        validators={validators}
                        changeAction={onChangeAction !== undefined ? this.onChangeAction : undefined}
                        disabled={disabled}
                    >
                        <option hidden>{placeholder}</option>
                        {this.displayOptions(fieldProp, options)}
                    </Control.select>
                </FloatingLabel>
                {
                }
            </div>
        );
    }
}

export class InventoryDatePicker extends Component {
    render() {
        const { hidden, label, className, placeholder, id, value, disabled, minDate } = this.props;
        const DatePickerText = forwardRef(({ onClick, value, disabled }, ref) => (
            <div onClick={onClick} className="icn-calendar">
                <input defaultValue={value} placeholder={'DD/MM/YYYY'} disabled={disabled} type="text" ref={ref} />
            </div>
        ));
        return (
            <Form.Group hidden={hidden} className="orf-d-p">
                <FloatingLabel controlId={label} label={label} hidden={hidden} className="label-datepicker" />
                <DatePicker
                    placeholder={placeholder}
                    className={'form-control ' + className}
                    popperClassName={'form-control ' + className}
                    id={id}
                    onChange={e => this.props.action(e)}
                    dateFormat="dd/MM/yyyy"
                    value={value}
                    selected={value}
                    customInput={<DatePickerText />}
                    disabled={disabled}
                    minDate={minDate}
                />
            </Form.Group>
        )
    }
}

